import { handleValidation } from "./validation.js";
import { updateScrollTriger } from "./updateScrollTriger.js";

const handleFormSubmit =  () => {
    //const queryParams = new URLSearchParams(window.location.search);
    const TURNSTILE_RESPONSE_FIELD = 'cf-turnstile-response';

    /*let turnstile_explicit = queryParams.get('turnstile_explicit');

    if (turnstile_explicit && turnstile_explicit === '1') {
        turnstile_explicit = true;
    } else {
        turnstile_explicit = false;
    }*/

    function updateLabelState(el, isActive) {
        const container = el.closest('.js-container');
        const inputId = el.getAttribute('id');
        const label = document.querySelector(`label[for="${inputId}"]`);

        if (!container || !label || el.type === 'checkbox') return;

        const placeholderText = el.placeholder || label.innerText;

        if (isActive) {
            container.setAttribute('data-placeholder', placeholderText);
            label.style.transition = 'all 0.6s ease';
            container.classList.add('active');
            label.classList.add('active');

            const tempLabel = createTemporaryLabel(placeholderText);
            const labelWidth = tempLabel.offsetWidth;

            tempLabel.remove();

            el.style.paddingRight = `${labelWidth + 25}px`;
        } else if (!el.value) {
            container.classList.remove('active');
            label.classList.remove('active');
            removeTemporaryLabel();
        }
    }

    function createTemporaryLabel(text) {
        const tempLabel = document.createElement('span');

        tempLabel.innerText = text;
        tempLabel.style.position = 'absolute';
        tempLabel.style.visibility = 'hidden';
        tempLabel.style.fontSize = '12px';
        tempLabel.classList.add('js-temp-label');

        document.body.appendChild(tempLabel);

        return tempLabel;
    }

    function removeTemporaryLabel() {
        const tempLabel = document.querySelector('.js-temp-label');

        if (tempLabel) {
            tempLabel.remove();
        }
    }

    function handleFocusIn(event) {
        if (event.target.closest('.js-container')) {
            updateLabelState(event.target, true);
        }
    }

    function handleFocusOut(event) {
        if (event.target.closest('.js-container')) {
            updateLabelState(event.target, false);
        }
    }

    function initFloatingLabels() {
        const customForm = document.querySelector('.js-sk-form');

        if (customForm) {
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
        }
    }

    // New recursive function to handle submission and retries
    function processFormSubmission(form, submitBtn, loader, message, attemptsLeft) {
        const formData = new FormData(form);
        const turnstileResponse = formData.get(TURNSTILE_RESPONSE_FIELD);

        //  Find the specific widget ID for the form being submitted
        const turnstileContainer = form.querySelector('.cf-turnstile');
        const currentWidgetId = turnstileContainer ? turnstileContainer.getAttribute('data-widget-id') : null;

        // 1. If captcha token is missing and we have attempts left, retry.
        if (!turnstileResponse && attemptsLeft > 0) {
            console.warn(`Captcha missing. Retrying... Attempts left: ${attemptsLeft}`);

            // Attempt to reset the Turnstile widget if the script has loaded
            if (window.turnstile && currentWidgetId) {
                try { window.turnstile.reset(currentWidgetId); } catch(e) { console.error(e); }
            }

            // Wait 2 seconds for it to load/solve, then call this function again
            setTimeout(() => {
                processFormSubmission(form, submitBtn, loader, message, attemptsLeft - 1);
            }, 2000);
            return;
        }

        // 2. If captcha token is missing and NO attempts are left, fail gracefully.
        if (!turnstileResponse && attemptsLeft === 0) {
            submitBtn.removeAttribute('disabled');
            loader.classList.add('hidden');
            message.innerText = "We could not connect to the security check. Please try again.";
            message.classList.remove('hidden');
            return;
        }

        // 3. If we have the token, proceed with the fetch request
        fetch(themeVars.ajax_url, {
            method: "POST",
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        })
        .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
        })
        .then((data) => {
            // Check if PHP returned a WordPress error (e.g., Turnstile verification failed)
            if (data.success === false) {
                const errorString = data.data || ''; // wp_send_json_error puts the string in data.data

                // If the server rejected the Turnstile token, we can try to reset and retry
                // Reset only the specific widget for this form on server failure
                if (typeof errorString === 'string' && errorString.includes('Turnstile') && attemptsLeft > 0) {
                    if (window.turnstile && currentWidgetId) {
                        try { window.turnstile.reset(currentWidgetId); } catch(e) { console.error(e); }
                    }
                    setTimeout(() => {
                        processFormSubmission(form, submitBtn, loader, message, attemptsLeft - 1);
                    }, 2000);
                    return;
                } else if (attemptsLeft === 0) {
                    submitBtn.removeAttribute('disabled');
                    loader.classList.add('hidden');
                    message.innerText = data.message || (data.data && data.data.message) || "We could not connect to the security check. Please try again.";
                    message.classList.remove('hidden');

                    return;
                }
            }

            // Success
            submitBtn.removeAttribute('disabled');
            loader.classList.add('hidden');

            // Determine the success message based on standard JSON response or WP success response
            message.innerText = data.message || (data.data && data.data.message) || "Success";

            setTimeout(() => {
                if (data.success !== false) {
                    form.remove();
                }

                message.classList.remove('hidden');
            }, 300);
            updateScrollTriger();
        })
        .catch((error) => {
            console.error("Fetch operation problem:", error);

            // If a network error happens, we can also retry
            if (attemptsLeft > 0) {
                setTimeout(() => {
                    processFormSubmission(form, submitBtn, loader, message, attemptsLeft - 1);
                }, 2000);
            } else {
                submitBtn.removeAttribute('disabled');
                loader.classList.add('hidden');
                message.innerText = "We could not connect to the server. Please, try again later";
                message.classList.remove('hidden');
            }
        });
    }

    function formSubmit() {
        const forms = document.querySelectorAll('.js-sk-form');

        forms.forEach((form) => {
            const message = form.nextElementSibling;
            const submit = form.querySelector('button[type=submit]');
            const loader = form.previousElementSibling;

            form.addEventListener('submit', function(e){
                e.preventDefault()
                const valid = handleValidation(form);

                if(!valid) {
                    updateScrollTriger();

                    return
                }

                submit.setAttribute('disabled', true);
                loader.classList.remove('hidden');
                message.classList.remove('small');

                /*if (turnstile_explicit) {*/
                    message.classList.add('hidden'); // Ensure message is hidden while loading/retrying

                    // Kick off the submission process allowing 3 attempts
                    processFormSubmission(form, submit, loader, message, 3);
                /*} else {
                    const formData = new FormData(this);

                    fetch(themeVars.ajax_url, {
                        method: "POST",
                        body: formData,
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                        },
                    })
                    .then((response) => {
                        if (!response.ok) throw new Error("Network response was not ok");

                        return response.json();
                    })
                    .then((data) => {
                        submit.removeAttribute('disabled');
                        loader.classList.add('hidden');

                        // message.innerText = data.message;
                        if (data.success === false) {
                            message.innerText = data.message || (data.data && data.data.message) || "We could not connect to the security check. Please try again.";
                        } else {
                            message.innerText = data.message || (data.data && data.data.message) || "Success";
                        }

                        setTimeout(() => {
                            if (data.success !== false) {
                                form.remove();
                            }

                            message.classList.remove('hidden');
                        }, 300)

                        updateScrollTriger()
                    })
                    .catch((error) => {
                        console.error("There was a problem with the fetch operation:", error);
                    });
                }*/
            });
        });
    }

    formSubmit();

    function ensureTurnstileResponseField(form) {
        let responseField = form.querySelector(`input[name="${TURNSTILE_RESPONSE_FIELD}"]`);

        if (!responseField) {
            responseField = document.createElement('input');
            responseField.type = 'hidden';
            responseField.name = TURNSTILE_RESPONSE_FIELD;

            form.appendChild(responseField);
        }

        return responseField;
    }

    function initTurnstileWidgets() {
      const forms = document.querySelectorAll('.js-sk-form');

      forms.forEach((form) => {
        const container = form.querySelector('.js-turnstile');

        if (!container) {
          return;
        }

        const responseField = ensureTurnstileResponseField(form);

        const widgetId = window.turnstile.render(container, {
          sitekey: "0x4AAAAAACAuishx4B9QIMKv",
          appearance: 'interaction-only',
          callback: (token) => {
            responseField.value = token;
          },
          'expired-callback': () => {
            responseField.value = '';
          },
          'error-callback': () => {
            responseField.value = '';
          },
        });

        container.setAttribute('data-widget-id', widgetId);
      });
    }

    return {
        init() {
            initFloatingLabels();

            //if (turnstile_explicit) {
                let attempts = 0;
                const maxAttempts = 100; // 100 attempts * 50ms = 5 seconds

                const waitForTurnstile = () => {
                    if (window.turnstile && typeof window.turnstile.render === 'function') {
                        initTurnstileWidgets();

                        return;
                    }

                    attempts++;

                    if (attempts >= maxAttempts) {
                        console.warn("Turnstile script was blocked from loading.");

                        const forms = document.querySelectorAll('.js-sk-form');

                        forms.forEach((form) => {
                            const message = form.nextElementSibling;
                            const submit = form.querySelector('button[type=submit]');

                            if (message && submit) {
                                submit.setAttribute('disabled', true);
                                message.classList.add('small');
                                message.innerText = "Our security check was blocked. If you are using a VPN or an Ad Blocker, please pause it to submit this form.";
                                message.classList.remove('hidden');
                            }
                        });

                        return;
                    }

                    window.setTimeout(waitForTurnstile, 50);
                };

                waitForTurnstile();
            //}
        },
    }
}


export {
    handleFormSubmit,
};
